module.exports = "../fonts/Circe.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Circe.otf
// module id = 592
// module chunks = 0